<template>
  <div class="controls-wrapper">
     <div v-if="!simple">
       <div class="controls-wrapper" v-if="!scope.pending && !scope.invite">
        <icon-button icon="users" fa @click="showGroupsDialog = true" v-if="canManageGroups" />
        <icon-button icon="dollar-sign" @click="showDialog = true" fa/>
        <icon-button :icon="adminStateIcon" @click="toggleOrganizationAdmin(scope)" />

        <el-dialog :append-to-body="true" v-if="showDialog" append-to-body width="400px" title="Add new price" :visible.sync="showDialog">
          <upsert-price-form
            v-if="showDialog"
            :userId="scope.user.id"
            :stations="organization.stations"
            @created="memberSpecificPriceCreated"
            :users="organizationUsers" />
        </el-dialog>

        <el-dialog
          :append-to-body="true"
          v-if="showGroupsDialog"
          append-to-body
          width="400px"
          :title="`Groups for ${scope.user.name}`"
          :visible.sync="showGroupsDialog">
          <member-groups-dialog
            v-if="showGroupsDialog"
            :member="scope"
            :organization="organization"
            @refresh="$emit('refresh')" />
        </el-dialog>
      </div>
      <div v-else class="controls-wrapper">
        <icon-button icon="el-icon-check" @click="acceptMembership(scope)" v-if="!scope.invite"/>
        <icon-button icon="el-icon-close" @click="cancelMembership(scope)"/>
      </div>
     </div>
     <div v-else>
       <div v-if="scope.user.id !== $auth.user.id">
          <div class="controls-wrapper" v-if="!scope.pending && simple">
            <icon-button icon="el-icon-close" @click="cancelMembership(scope)"/>
          </div>
          <el-tooltip
            v-else
            :content="scope.invite ? 'Invitation sent — awaiting response' : 'Membership request — awaiting approval'"
            placement="top">
            <i
              class="new-user-icon"
              :class="[scope.invite ? 'invite el-icon-message' : 'request el-icon-warning-outline']" />
          </el-tooltip>
       </div>
     </div>
  </div>
</template>

<script>
import UpsertPriceForm from './../Pricing/UpsertForm'
import MemberGroupsDialog from './MemberGroupsDialog'

export default {
  name: 'MemberControls',
  components: { UpsertPriceForm, MemberGroupsDialog },
  props: {
    organization: {
      type: Object,
      required: false
    },
    member: {
      type: Object,
      required: true
    },
    simple: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      scope: this.member,
      showDialog: false,
      showGroupsDialog: false
    }
  },
  computed: {
    organizationUsers () {
      return this.organization.users.map(user => {
        return user.user
      })
    },
    adminStateIcon () {
      return !this.member.isOrganizationAdmin ? 'el-icon-star-off' : 'el-icon-star-on'
    },
    canManageGroups () {
      return this.$auth.user.isSystem || this.$root.isAdmin
    }
  },
  watch: {
    member () {
      this.scope = this.member
    }
  },
  methods: {
    memberSpecificPriceCreated (price) {
      this.$emit('priceCreated', price)
      this.showDialog = false
    },
    async toggleOrganizationAdmin (orgUser) {
      if (!this.$auth.user.isSystem && orgUser.user.id === this.$auth.user.id) {
        return
      }
      orgUser.isOrganizationAdmin = !orgUser.isOrganizationAdmin
      const data = { isOrganizationAdmin: orgUser.isOrganizationAdmin }
      const response = await this.$http.put(this.$api.organizations.users.update(this.$route.params.orgId, orgUser.user.id), data)
    },
    async acceptMembership (user) {
      const data = { pending: false, invite: false }
      const response = await this.$http.put(this.$api.organizations.users.update(this.$route.params.orgId, user.user.id, true), data)
      user.pending = false
      this.$emit('update:member', user)
    },
    cancelMembership (user) {
      const isPending = user.pending || user.invite
      const name = user.user && user.user.name ? user.user.name : 'this user'
      const message = isPending
        ? `Cancel the membership invite for ${name}?`
        : `Remove ${name} from this organization? This cannot be undone.`

      this.$confirm(message, 'Are you sure?', {
        confirmButtonText: isPending ? 'Cancel invite' : 'Remove',
        cancelButtonText: 'Keep',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http.delete(this.$api.organizations.users.delete(this.$route.params.orgId, user.user.id))
          this.$message.success(isPending ? 'Invite cancelled' : 'Member removed')
          this.$emit('remove', user)
        } catch (e) {
          this.$message.error('Could not remove member')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
  .controls-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .new-user-icon {
    font-size: 16px;
    cursor: help;

    &.invite {
      color: #67c23a;
    }

    &.request {
      color: #f7ba2a;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Members/MemberControls.vue